module.exports = __webpack_public_path__ + "static/media/klasa_5.b5543bb7.svg";